import React from "react";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import { Icon, notification, Spin } from "antd";
import { Redirect } from "react-router";
import PropTypes from "prop-types";
import { Titlebar } from "../../../components";
import LayoutContent from "../../../layouts/app/layoutContent";
import LayoutContentWrapper from "../../../layouts/app/layoutWrapper";
import CompanyForm from "./form";
import { AccountContext } from "../../../context/AccountContext";

class CompanyMailerEdit extends React.Component {
  static contextType = AccountContext;
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      redirectTo: null,
      pageTitle: `Edit Company Mailer Template`,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleLoading = this.toggleLoading.bind(this);
    this.userContext = null;
  }

  toggleLoading(boolean) {
    this.setState({
      loading: boolean,
    });
  }

  handleSubmit(values) {
    this.setState({
      loading: true,
    });

    const variables = {
      ...values,
      id: this.props.data.getPortal.id,
    };

    // console.log('submit form');

    this.props
      .editPortalMailer({ variables })
      .then(({ data }) => {
        if (data.editPortalMailer.ok && !data.editPortalMailer.errors) {
          this.handleSuccess(`${data.editPortalMailer.portal.name} has been successfully updated.`);
          return;
        }

        this.handleError(data.editPortalMailer.errors);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleSuccess(description, action) {
    notification.success({
      message: "Company Updated Successfully",
      //description,
    });

    this.props.history.push("/company");
    // this.setState({ redirectTo: '/practices' });
  }

  handleError(errors) {
    this.setState({ loading: false });

    errors.forEach((err) => {
      notification.error({
        message: "Error",
        description: err.message,
      });
    });
  }

  componentDidUpdate() {
    this.userContext = this.context;
  }

  render() {
    const {
      data: { loading, error, getPortal },
    } = this.props;

    if (loading) {
      return (
        <div className="unirifi-costomer-layout-wrapper">
          <div className="unitifi-subheader-bar-wrapper">
            <Titlebar currentPractice={this.props.currentPractice} displayText={this.state.pageTitle} />
          </div>
          <div className="loading-wrapper">
            <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} />
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="unirifi-costomer-layout-wrapper">
          <div className="unitifi-subheader-bar-wrapper">
            <Titlebar currentPractice={this.props.currentPractice} displayText={this.state.pageTitle} />
          </div>
          <div className="loading-wrapper">
            <p>Whoopsie - practice didn&apos;t load.</p>
          </div>
        </div>
      );
    }

    return (
      <div className="unirifi-costomer-layout-wrapper">
        <div className="unitifi-subheader-bar-wrapper">
          <Titlebar currentPractice={this.props.currentPractice} displayText={this.state.pageTitle} />
        </div>
        <LayoutContentWrapper>
          <LayoutContent>
            <CompanyForm loading={this.state.loading} onDelete={this.handleDeleteConfirm} onSubmit={this.handleSubmit} company={getPortal} toggleLoading={this.toggleLoading} userContext={this.userContext} />
            {this.state.redirectTo !== null && <Redirect to={this.state.redirectTo} />}
          </LayoutContent>
        </LayoutContentWrapper>
      </div>
    );
  }
}

CompanyMailerEdit.propTypes = {
  editPortalMailer: PropTypes.func.isRequired,
};

const getCompanyQuery = gql`
  query($id: Int!) {
    getPortal(id: $id) {
      id
      name
      email
      slug
      description
      status
      siteLogo
      address
      siteLogoS3Token
      primaryContactAddress
      primaryContactZipCode
      primaryContactCity
      primaryContactCountry
      primaryContactState
      primaryContactSuite
      primaryContactEmail
      primaryContactFirstName
      primaryContactLastName
      total_clients
      total_practice
      team_size
      assessmentNotification
      clientAssessmentTitle
      clientAssessmentBody
      userInviteTitle
      userInviteBody
      userInviteDomain
      user {
        id
        firstName
        lastName
        email
        lastLogin
      }
    }
  }
`;

const CompanyMailerMutation = gql`
  mutation editPortalMailer($id: Int!, $clientAssessmentTitle: String, $clientAssessmentBody: String, $userInviteTitle: String, $userInviteBody: String) {
    editPortalMailer(id: $id, clientAssessmentTitle: $clientAssessmentTitle, clientAssessmentBody: $clientAssessmentBody, userInviteTitle: $userInviteTitle, userInviteBody: $userInviteBody) {
      portal {
        name
      }
      ok
      errors {
        message
        path
      }
    }
  }
`;

export default compose(
  graphql(getCompanyQuery, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        id: Number(props.match.params.id),
      },
    }),
  }),
  graphql(CompanyMailerMutation, { name: "editPortalMailer" })
)(CompanyMailerEdit);
